import styled from 'styled-components';
import { Flexbox } from '@hiiretail/synergy-ui';

export const ServiceCard = styled(Flexbox)`
  min-height: 300px;
  padding: ${(props) => props.theme.spacing(4)}px;
  background: #FFFFFF;
  cursor: pointer;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08), 0 2px 6px rgba(0, 0, 0, 0.12);
  border-radius: 8px;

`;

export const ServiceCardHeader = styled(Flexbox)`
  width: 100%;
  height: 30%;
  margin-bottom: ${(props) => props.theme.spacing(4)}px;
`;

export const ServiceCardBody = styled(Flexbox)`
  width: 100%;
  height: 70%;
`;
